module.exports = __webpack_public_path__ + "img/data_overview_map_bottom.3eafed47.png";